<template>
    <div>
        <p class="text-14 text-grey-900 pb-1">Email addresses</p>

        <Communication
            v-for="comm in communications.filter((c) => c.type == 1)"
            :key="comm.id"
            :comm="comm"
            :type="comm.type"
            :modelType="modelType"
            :modelId="modelId"
            :owner="owner"
            :canBeToggled="communications.filter((c) => c.type == 1).length > 1 || adding.filter((a) => a.type == 'email').length > 0"
            @hasSaved="hasSaved"
            @hasDeleted="hasDeleted"
            @error="hasErrored"
        />

        <template v-for="(comm, ci) in adding">
            <Communication
                :key="ci - 20"
                :type="1"
                :modelType="modelType"
                :modelId="modelId"
                :canBeToggled="true"
                :owner="owner"
                v-if="comm.type == 'email'"
                @hasSaved="hasSaved"
                @hasDeleted="hasDeleted"
                @error="hasErrored"
            />
        </template>

        <button class="flex items-center mt-3" @click="add('email')" type="button">
            <IconPlus class="stroke-black w-4.5 h-4.5" />
            <p class="pl-2 text-grey-900 text-14">Add an additional email</p>
        </button>

        <p class="text-14 text-grey-900 pb-1 mt-4.5">Phone numbers</p>

        <Communication
            v-for="comm in communications.filter((c) => c.type == 0)"
            :key="comm.id"
            :comm="comm"
            :type="comm.type"
            :modelType="modelType"
            :modelId="modelId"
            :owner="owner"
            :canBeToggled="communications.filter((c) => c.type == 0).length > 1 || adding.filter((a) => a.type == 'number').length > 0"
            @hasSaved="hasSaved"
            @hasDeleted="hasDeleted"
            @error="hasErrored"
        />

        <template v-for="(comm, ci) in adding">
            <Communication
                :key="ci - 20"
                :type="0"
                :modelType="modelType"
                :modelId="modelId"
                :canBeToggled="true"
                :owner="owner"
                v-if="comm.type == 'number'"
                @hasSaved="hasSaved"
                @hasDeleted="hasDeleted"
                @error="hasErrored"
            />
        </template>

        <button class="flex items-center mt-3" @click="add('number')" type="button">
            <IconPlus class="stroke-black w-4.5 h-4.5" />
            <p class="pl-2 text-grey-900 text-14">Add an additional number</p>
        </button>
    </div>
</template>

<script>
import Communication from '~/models/communication.js'
import CommunicationComponent from '~/components/customer/input/communication.vue'

export default {
    props: {
        communications: Array,
        modelType: String,
        modelId: Number,
        owner: Object,
    },

    data() {
        return {
            adding: [],
            savedCount: 0,
            saving: false,
        }
    },

    methods: {
        add(type) {
            this.adding.push({
                type: type,
                index: this.adding.length,
            })
        },

        save() {
            if (this.saving) {
                return
            }

            // console.log('adding', this.adding.length)

            this.saving = true
            this.savedCount = 0
            this.$event.$emit('communication-save')
        },

        destroy() {
            // console.log('destroy', this.saving)
            if (this.saving) {
                return
            }
            this.saving = true
            this.savedCount = 0
            this.$event.$emit('communication-delete')
        },

        hasDeleted() {
            this.savedCount++
            // console.log('hasDeleted '+this.savedCount, this.communications.length)

            if (this.communications.length == this.savedCount) {
                this.savedCount = 0
                this.saving = false

                this.$emit('saved')
                this.$event.$emit('page-update')
            }
        },

        hasSaved() {
            this.savedCount++

            let total = this.communications.length + this.adding.length

            // console.log([this.savedCount, total, this.communications.length, this.adding.length])

            if (this.savedCount == total) {
                this.adding = null
                this.adding = []

                // console.log('fully saved');
                // this.$emit('saved');

                // this.$event.$emit('page-update')

                this.saving = false
                this.savedCount = 0

                this.$event.$emit('toast-new-message', 'Contact options updated')

                this.destroy()
            }
        },

        hasErrored() {
            this.saving = false
            this.savedCount = 0
        },
    },

    components: {
        Communication: CommunicationComponent,
    },
}
</script>
